<template>
    <div>
        <div class="row zp-central-contenedor es_central" v-if="es_central == '1'" >
            <div :class="ejecutivos.length == 1 ? '' : 'col-sx-6 col-sm-6 col-md-6 col-lg-6 col-xl-4 pl-0 pr-0'" v-for="(ejecutivo,indexC) in ejecutivos"
            :key="indexC" @click="seleccionaContacto(indexC)">
                <div class="tippy-container" content="Selecciona un contacto" :ref="'ContactTippy'+indexC" v-tippy="{ placement : 'bottom',  arrow: true , trigger : 'mouseenter'}"></div>
                <div :class="ejecutivos.length == 1 ? 'float-left mr-2' : ''" v-if="ejecutivo.tiene_imagen == '1'">
                    <div><img :src="ejecutivo.imagen" :class="ejecutivos.length == 1 ? 'zp-imagen-contacto-central zp-imagen-100':'zp-imagen-contacto-central' "></div>
                </div>
                <div :class="ejecutivos.length == 1 ? 'float-left zp-datos-ejecutivo mb-3' : 'zp-datos-ejecutivo mb-3'">
                    <h6 class="zp-subtitulo-formulario consulta mt-2 mb-1" v-show="ejecutivo.nombre != ''"><i class="fas fa-user mr-2"></i>{{ejecutivo.nombre}}</h6>
                    <h6 class="zp-subtitulo-formulario telefono mt-0 mb-1" v-show="ejecutivo.telefono != ''"><i class="fas fa-phone-alt mr-2"></i>+56 {{ejecutivo.telefono}}</h6>
                    <h6 class="zp-subtitulo-formulario ejectivo mt-0 mb-1" v-show="ejecutivo.email != ''"><i class="fas fa-envelope mr-2"></i>{{ejecutivo.email}}</h6>
                </div>
                <div v-if="indice_seleccionado == indexC && ejecutivos.length > 1" class="zp-span_menu_active zp-contacto-seleccionado"></div>
            </div>
        </div>
        <div class="row zp-sidebar-contenedor no_es_central" v-if="es_central == '0'">
            <div :class="ejecutivos.length == 1 ? 'd-flex col-12' : 'col-sx-6 col-sm-6 col-md-6 col-lg-6' " v-for="(ejecutivo,indexC) in ejecutivos"
            :key="indexC" @click="seleccionaContacto(indexC)">
                <div class="tippy-container" content="Selecciona un contacto" :ref="'ContactTippy'+indexC" v-tippy="{ placement : 'bottom',  arrow: true , trigger : 'mouseenter'}"></div>
                <div :class="ejecutivos.length == 1 ? 'd-inline-flex mr-2' : ''" v-if="ejecutivo.tiene_imagen == '1'">
                    <div><img :src="ejecutivo.imagen" :class="ejecutivos.length == 1 ? 'zp-imagen-contacto-central zp-imagen-100':'zp-imagen-contacto-central' "></div>
                </div>
                <div :class="ejecutivos.length == 1 ? '' : 'zp-datos-ejecutivo mb-2' ">
                    <h6 class="zp-subtitulo-formulario consulta mt-2 mb-0" v-show="ejecutivo.nombre != ''"><i class="fas fa-user mr-1"></i>{{ejecutivo.nombre}}</h6>
                    <h6 class="zp-subtitulo-formulario telefono mt-0 mb-0" v-show="ejecutivo.telefono != ''"><i class="fas fa-phone-alt mr-1"></i>+56 {{ejecutivo.telefono}}</h6>
                    <h6 class="zp-subtitulo-formulario ejectivo mt-0 mb-0" v-show="ejecutivo.email != ''"><i class="fas fa-envelope mr-1"></i>{{ejecutivo.email}}</h6>
                </div>
                <div v-if="indice_seleccionado == indexC && ejecutivos.length > 1" class="zp-span_menu_active zp-contacto-seleccionado"></div>
            </div>
        </div>

    </div>
</template>
<script>
    import VueTippy, { TippyComponent } from "vue-tippy";
    Vue.use(VueTippy);
    Vue.component("tippy", TippyComponent);

    export default {
        name: "EjecutivosContactoProyecto",
        props: [
            "es_central",
            "medias",
            "contactosconsulta",
            "contactosejecutivos",
            "contactostelefonos",
        ],
        data: function() {
            return  {
                ejecutivos:[],
                indice_seleccionado:-1
            }
        },
        mounted() {
            let medias = [];
            if(this.medias){
                medias = this.medias.filter((media) => media.tipo_id == 9);
            }
            let orden_iniciador = 0;

            if(this.contactosconsulta){
                this.contactosconsulta.forEach(obj => {
                    let nombre = this.contactosejecutivos.filter((element) => parseInt(element.orden) == parseInt(obj.orden))[0];
                    if(nombre == undefined){
                        nombre = {nombre:'',id:'0'};
                    }
                    let telefono = this.contactostelefonos.filter((element) => parseInt(element.orden) == parseInt(obj.orden))[0];
                    if(telefono == undefined){
                        telefono = {nombre:'',id:'0'};
                    }
                    let imagen = medias.filter((element) => parseInt(element.orden) == parseInt(obj.orden))[0];

                    if(obj.orden == null){
                        obj.orden = orden_iniciador;
                        orden_iniciador++;
                    }
                    this.ejecutivos.push({
                        nombre:nombre.nombre,
                        nombre_id:nombre.id,
                        email:obj.nombre,
                        email_id:obj.id,
                        telefono:telefono.nombre,
                        telefono_id:telefono.id,
                        imagen: imagen == undefined ? '' : imagen.url,
                        orden:obj.orden,
                        tiene_imagen: imagen == undefined ? '0' : '1'
                    });
                });
            }

            if(this.ejecutivos.length > 0){
                this.seleccionaContacto(0);
            }
        },
        methods:{
            seleccionaContacto(indice){
                this.indice_seleccionado = indice;
                let event = new CustomEvent("selecciona-contacto",{ detail: this.ejecutivos[indice] });
                document.dispatchEvent(event);
                this.ejecutivos.map((contact,index) => {
                    if(this.$refs['ContactTippy'+index] != undefined){
                        if (this.$refs['ContactTippy'+index].length >= 1) {
                            this.$refs['ContactTippy'+index][0]._tippy.hide();
                            this.$refs['ContactTippy'+index][0]._tippy.disable();
                        }
                    }
                })
                setTimeout(() => {
                    this.ejecutivos.map((contact,index) => {
                        if(this.$refs['ContactTippy'+index] != undefined){
                            if (this.$refs['ContactTippy'+index].length >= 1) {
                                this.$refs['ContactTippy'+index][0]._tippy.hide();
                                this.$refs['ContactTippy'+index][0]._tippy.disable();
                            }
                        }
                    })
                }, 1000);
            }
        }
    }
</script>
<style>
.tippy-container{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 150px;
  height: 100%;
}
.zp-imagen-100{
    max-height: 100px !important;
    max-width: 100px !important;
}
.zp-image-ejecutivo{
    max-width: 75px;
    height: 75px;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
    transition: 0.5s ease;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}
.zp-imagen-contacto-central{
    width: 150px;
    height: 150px;
    max-width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
}
.zp-central-contenedor .zp-subtitulo-formulario{
    word-wrap: anywhere;
    display: inline-flex;
    font-size: 13px;
    width: 100%;
}

.zp-sidebar-contenedor .zp-subtitulo-formulario{
    word-wrap: anywhere;
    display: inline-flex;
    font-size: 11px;
    width: 100%;
}
.zp-contacto-seleccionado{
    max-width: 100%;
    width: 150px;
}
@media (max-width: 989px) and (min-width: 10px){
    .zp-sidebar-contenedor .zp-subtitulo-formulario{
        font-size: 13px;
        width: 100%;
    }
}
@media (max-width: 1200px) and (min-width: 990px){
   .zp-sidebar-contenedor .zp-subtitulo-formulario{
        font-size: 12px;
        width: 100%;
    }
    .zp-sidebar-contenedor .col-lg-6{
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
    }
}
</style>